import PropTypes from "prop-types";
import { Skeleton, Table } from "antd";

const TableSkeleton = ({ rows, columns }) => {
  const dataSource = Array.from({ length: rows }, (_, rowIndex) => {
    const row = {};
    for (let colIndex = 0; colIndex < columns; colIndex++) {
      row[`col${colIndex}`] = (
        <Skeleton active paragraph={false} title={{ width: "80%" }} />
      );
    }
    row.key = rowIndex;
    return row;
  });
  const tableColumns = Array.from({ length: columns }, (_, colIndex) => ({
    title: <Skeleton active paragraph={false} title={{ width: "60%" }} />,
    dataIndex: `col${colIndex}`,
    key: `col${colIndex}`,
  }));
  return (
    <Table dataSource={dataSource} columns={tableColumns} pagination={false} />
  );
};

TableSkeleton.propTypes = {
  rows: PropTypes.number.isRequired,
  columns: PropTypes.number.isRequired,
};

export default TableSkeleton;
